const router = {
  path: "/app/workLeave",
  redirect: "app/workLeave/draft",
  component: () => import("@/views/mainApp/components/workLeaveApp/layout"),
  meta: {
    authRequired: true,
    hidden: true,
  },
  children: [
    {
      name: "myReportWorkLeaveEmployee",
      path: "schedule-work-leave-employee",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/HRScheduleWorkLeaveEmployee"
        ),
      props: true,
      meta: {
        appName: "myReportWorkLeaveEmployee",
      },
      children: [
        {
          name: "detailMyReportWorkLeaveEmployee",
          path: "/schedule-work-leave-employee/:idWorkLeave/view",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approval/DetailWorkLeaveApproval"
            ),
          props: true,
        },
      ],
    },
    {
      name: "myReportManagerWorkLeaveEmployee",
      path: "schedule-manager-work-leave-employee",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/DMScheduleWorkLeaveEmployee"
        ),
      props: true,
      meta: {
        appName: "myReportManagerWorkLeaveEmployee",
      },
      children: [
        {
          name: "detailMyReportManagerWorkLeaveEmployee",
          path: "/schedule-manager-work-leave-employee/:idWorkLeave/view",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approval/DetailWorkLeaveApproval"
            ),
          props: true,
        },
      ],
    },
    {
      name: "reportDepartmentWorkLeaveInMonth",
      path: "report-department-work-leave-in-month",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ReportDepartmentInMonth"
        ),
      props: true,
      meta: {
        appName: "reportDepartmentWorkLeaveInMonth",
      },
      children: [
        {
          name: "detailReportDepartmentWorkLeaveInMonth",
          path: "/report-department-work-leave-in-month/:idWorkLeave/view",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approval/DetailWorkLeaveApproval"
            ),
          props: true,
        },
      ],
    },
    {
      name: "statisticHREmployee",
      path: "/app/workLeave/statistic-hr-employee-year",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/HRStatisticInYearEmployee"
        ),
      meta: {
        appName: "statisticHREmployee",
      },
      props: true,
    },
    {
      name: "statisticWeekHREmployee",
      path: "/app/workLeave/statistic-hr-employee-week",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/HRStatisticInWeekEmployee"
        ),
      meta: {
        appName: "statisticWeekHREmployee",
      },
      props: true,
    },
    {
      name: "statisticManagerDepartment",
      path: "/app/workLeave/statistic-manager-department-year",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/DMStatisticInYearDepartment"
        ),
      meta: {
        appName: "statisticManagerDepartment",
      },
      props: true,
    },
    {
      name: "statisticReportDepartment",
      path: "/app/workLeave/statistic-report-department-year",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ReportDepartmentInYear"
        ),
      meta: {
        appName: "statisticReportDepartment",
      },
      props: true,
    },
    {
      name: "statisticWeekDepartmentEmployee",
      path: "/app/workLeave/statistic-department-employee-week",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/DMStatisticInWeekEmployee"
        ),
      meta: {
        appName: "statisticWeekDepartmentEmployee",
      },
      props: true,
    },
    {
      name: "addWorkLeave",
      path: "add",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveAdd"),
      props: true,
    },
    {
      name: "myReportWorkLeave",
      path: "report",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/MyReport"),
      props: true,
      meta: {
        appName: "myReportWorkLeave",
      },
    },
    {
      name: "calendarWorkLeaveDay",
      path: "my-calendar",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/MyCalendarWorkLeaveDay"
        ),
      props: true,
      meta: {
        appName: "calendarWorkLeaveDay",
      },
    },
    {
      name: "draftWorkLeaves",
      path: "draft",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveDrafts"),
      props: true,
      meta: {
        appName: "draftWorkLeaves",
      },
    },
    {
      name: "editingWorkLeaves",
      path: "editing",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveEditings"),
      props: true,
      meta: {
        appName: "editingWorkLeaves",
      },
    },
    {
      name: "submittingWorkLeaves",
      path: "submitting",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveSubmittings"),
      props: true,
      meta: {
        appName: "submittingWorkLeaves",
      },
    },
    {
      name: "approvedWorkLeaves",
      path: "approved",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveApproveds"),
      props: true,
      meta: {
        appName: "approvedWorkLeaves",
      },
    },
    {
      name: "rejectedWorkLeaves",
      path: "rejected",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveRejecteds"),
      props: true,
      meta: {
        appName: "rejectedWorkLeaves",
      },
    },

    // For HR
    {
      name: "HRWorkLeaves",
      path: "work-leave-hr",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/HRApprovedWorkLeaves"),
      props: true,
      meta: {
        appName: "HRWorkLeaves",
      },
    },

    // For Department Managers
    {
      name: "departmentManagerWorkLeaves",
      path: "work-leave-department-manager",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/DMApprovedWorkLeaves"),
      props: true,
      meta: {
        appName: "departmentManagerWorkLeaves",
      },
    },

    // all
    {
      name: "detailWorkLeave",
      path: ":idWorkLeave/detail",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveDetail"),
      props: true,
    },
    {
      name: "detailWorkLeaveHR",
      path: ":idWorkLeave/detail-hr",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveDetailHR"),
      props: true,
    },
    {
      name: "detailWorkLeaveDM",
      path: ":idWorkLeave/detail-manager",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveDetailDM"),
      props: true,
    },
    {
      name: "viewWorkLeave",
      path: ":idWorkLeave/view",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/WorkLeaveView"),
      props: true,
    },
    {
      name: "waitingApprovalWorkLeaves",
      path: "approvalWorkLeave/waiting",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ApprovalWorkLeaveWaitings"
        ),
      props: true,
      meta: {
        appName: "waitingApprovalWorkLeaves",
        appType: "approval",
        detailName: "detailApprovalWorkLeave",
      },
      children: [
        {
          path: "approvalWorkLeave/waiting/:idWorkLeave/approval",
          name: "detailApprovalWorkLeave",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approval/DetailWorkLeaveApproval"
            ),
          meta: {
            appName: "waitingApprovalWorkLeaves",
            appType: "approval",
            detailName: "detailApprovalWorkLeave",
          },
          props: { isApproval: true, isClose: true },
        },
      ],
    },
    {
      name: "doneApprovalWorkLeaves",
      path: "approvalWorkLeave/done",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ApprovalWorkLeaveDones"
        ),
      props: true,
      meta: {
        appName: "doneApprovalWorkLeaves",
        appType: "approval",
        detailName: "detailDoneApprovalWorkLeave",
      },
      children: [
        {
          path: "approvalWorkLeave/done/:idWorkLeave/approval",
          name: "detailDoneApprovalWorkLeave",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approval/DetailWorkLeaveApproval"
            ),
          meta: {
            appName: "doneApprovalWorkLeaves",
            appType: "approval",
            detailName: "detailDoneApprovalWorkLeave",
          },
          props: { isApproval: false, isClose: true },
        },
      ],
    },
    // approval attendance sheet
    {
      name: "waitingAttendanceSheets",
      path: "/approvalAttendanceSheet/waiting",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ApprovalAttendanceSheetWaitings"
        ),
      props: true,
      meta: {
        appName: "waitingAttendanceSheets",
        appType: "approval",
        detailName: "detailWaitingAttendanceSheet",
      },
      children: [
        {
          path: "/approvalAttendanceSheet/waiting/:idAttendanceSheet/approval",
          name: "detailWaitingAttendanceSheet",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approvalAttendanceSheet/DetailAttendanceSheetApproval"
            ),
          meta: {
            appName: "waitingAttendanceSheets",
            appType: "approval",
            detailName: "detailWaitingAttendanceSheet",
          },
          props: { isApproval: true, isClose: true },
        },
      ],
    },
    {
      name: "doneAttendanceSheets",
      path: "/approvalAttendanceSheet/done",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/ApprovalAttendanceSheetDones"
        ),
      props: true,
      meta: {
        appName: "doneAttendanceSheets",
        appType: "approval",
        detailName: "detailDoneAttendanceSheet",
      },
      children: [
        {
          path: "/approvalAttendanceSheet/done/:idAttendanceSheet/approval",
          name: "detailDoneAttendanceSheet",
          component: () =>
            import(
              "@/views/mainApp/components/workLeaveApp/components/approvalAttendanceSheet/DetailAttendanceSheetApproval"
            ),
          meta: {
            appName: "doneAttendanceSheets",
            appType: "approval",
            detailName: "detailDoneAttendanceSheet",
          },
          props: { isApproval: true, isClose: true },
        },
      ],
    },
    {
      name: "addAttendanceSheet",
      path: "attendance-sheet/add",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/AttendanceSheetAdd"),
      props: true,
      meta: {
        appName: "addAttendanceSheet",
      },
    },
    {
      name: "attendanceSheets",
      path: "attendance-sheet",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/AttendanceSheets"),
      props: true,
      meta: {
        appName: "attendanceSheets",
      },
    },
    {
      name: "HRAttendanceSheetsNotSubmit",
      path: "hr-attendance-sheet-not-submit",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/UnsubmittedAttendance"),
      props: true,
      meta: {
        appName: "HRAttendanceSheetsNotSubmit",
      },
    },
    {
      name: "HRAttendanceSheetInMonths",
      path: "attendance-sheet-in-month",
      component: () =>
        import(
          "@/views/mainApp/components/workLeaveApp/HRAttendanceSheetInMonths"
        ),
      props: true,
      meta: {
        appName: "HRAttendanceSheetInMonths",
      },
    },
    {
      name: "departmentManagerAttendanceSheets",
      path: "department-manager-attendance-sheet",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/DMAttendanceSheets"),
      props: true,
      meta: {
        appName: "departmentManagerAttendanceSheets",
      },
    },
    {
      name: "hrAttendanceSheets",
      path: "hr-attendance-sheet",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/HRAttendanceSheets"),
      props: true,
      meta: {
        appName: "hrAttendanceSheets",
      },
    },
    {
      name: "departmentManagerAttendanceSheetView",
      path: "department-manager-attendance-sheet/:idAttendanceSheet/view",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/DMAttendanceSheetView"),
      props: true,
      meta: {
        appName: "departmentManagerAttendanceSheetView",
      },
    },
    {
      name: "editAttendanceSheet",
      path: "attandance-sheet/:idAttendanceSheet/edit",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/AttendanceSheetEdit"),
      props: true,
      meta: {
        appName: "editAttendanceSheet",
      },
    },
    {
      name: "editAttendanceSheetDM",
      path: "attandance-sheet-department-manager/:idAttendanceSheet/edit",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/AttendanceSheetEditDM"),
      meta: {
        appName: "editAttendanceSheetDM",
      },
    },
    {
      name: "viewAttendanceSheet",
      path: "attandance-sheet/:idAttendanceSheet/view",
      component: () =>
        import("@/views/mainApp/components/workLeaveApp/AttendanceSheetView"),
      props: true,
      meta: {
        appName: "viewAttendanceSheet",
      },
    },
  ],
};

export default router;
